"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The CaseResp model module.
 * @module model/CaseResp
 * @version 1.0.0
 */
var CaseResp = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CaseResp</code>.
   * @alias module:model/CaseResp
   */
  function CaseResp() {
    _classCallCheck(this, CaseResp);

    CaseResp.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(CaseResp, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>CaseResp</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CaseResp} obj Optional instance to populate.
     * @return {module:model/CaseResp} The populated <code>CaseResp</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CaseResp();

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }

        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient.default.convertToType(data['status'], 'String');
        }

        if (data.hasOwnProperty('law_enforcement_agency')) {
          obj['law_enforcement_agency'] = _ApiClient.default.convertToType(data['law_enforcement_agency'], 'String');
        }

        if (data.hasOwnProperty('reported_date')) {
          obj['reported_date'] = _ApiClient.default.convertToType(data['reported_date'], 'String');
        }

        if (data.hasOwnProperty('submitted_date')) {
          obj['submitted_date'] = _ApiClient.default.convertToType(data['submitted_date'], 'String');
        }

        if (data.hasOwnProperty('how_submitted')) {
          obj['how_submitted'] = _ApiClient.default.convertToType(data['how_submitted'], 'String');
        }

        if (data.hasOwnProperty('met_media')) {
          obj['met_media'] = _ApiClient.default.convertToType(data['met_media'], 'String');
        }

        if (data.hasOwnProperty('social_media_post_date')) {
          obj['social_media_post_date'] = _ApiClient.default.convertToType(data['social_media_post_date'], 'String');
        }

        if (data.hasOwnProperty('written_spotlight_date')) {
          obj['written_spotlight_date'] = _ApiClient.default.convertToType(data['written_spotlight_date'], 'String');
        }

        if (data.hasOwnProperty('fb_live_feature_date')) {
          obj['fb_live_feature_date'] = _ApiClient.default.convertToType(data['fb_live_feature_date'], 'String');
        }

        if (data.hasOwnProperty('on_tv_date')) {
          obj['on_tv_date'] = _ApiClient.default.convertToType(data['on_tv_date'], 'String');
        }

        if (data.hasOwnProperty('news_outlet')) {
          obj['news_outlet'] = _ApiClient.default.convertToType(data['news_outlet'], 'String');
        }

        if (data.hasOwnProperty('user_id')) {
          obj['user_id'] = _ApiClient.default.convertToType(data['user_id'], 'Number');
        }
      }

      return obj;
    }
  }]);

  return CaseResp;
}();
/**
 * @member {Number} id
 */


CaseResp.prototype['id'] = undefined;
/**
 * @member {String} status
 */

CaseResp.prototype['status'] = undefined;
/**
 * @member {String} law_enforcement_agency
 */

CaseResp.prototype['law_enforcement_agency'] = undefined;
/**
 * @member {String} reported_date
 */

CaseResp.prototype['reported_date'] = undefined;
/**
 * @member {String} submitted_date
 */

CaseResp.prototype['submitted_date'] = undefined;
/**
 * @member {String} how_submitted
 */

CaseResp.prototype['how_submitted'] = undefined;
/**
 * @member {String} met_media
 */

CaseResp.prototype['met_media'] = undefined;
/**
 * @member {String} social_media_post_date
 */

CaseResp.prototype['social_media_post_date'] = undefined;
/**
 * @member {String} written_spotlight_date
 */

CaseResp.prototype['written_spotlight_date'] = undefined;
/**
 * @member {String} fb_live_feature_date
 */

CaseResp.prototype['fb_live_feature_date'] = undefined;
/**
 * @member {String} on_tv_date
 */

CaseResp.prototype['on_tv_date'] = undefined;
/**
 * @member {String} news_outlet
 */

CaseResp.prototype['news_outlet'] = undefined;
/**
 * @member {Number} user_id
 */

CaseResp.prototype['user_id'] = undefined;
var _default = CaseResp;
exports.default = _default;